// 列表组件需要的数据
export const OPTHINES = {
  voteName: '2020project/2020hometownstory',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  listData: {
    type: 'com',
  },
  themeColor: {
    activeBgColor: 'rgb(19, 86, 128)',
    inactiveBgColor: 'rgb(187, 211, 220)',
  },
  tabs: [
    {
      tabName: '活动介绍',
      tabPath: '/20200601GLGS/Rules',
    },
    {
      tabName: '镇街介绍',
      tabPath: '/20200601GLGS/One',
    },
    {
      tabName: '视频看看',
      tabPath: '/20200601GLGS/Two',
    },
    {
      tabName: '镇街故事',
      tabPath: '/20200601GLGS/News',
    },
  ],
};
